import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=797c27c4&scoped=true&lang=pug&"
import script from "./page-title.vue?vue&type=script&lang=js&"
export * from "./page-title.vue?vue&type=script&lang=js&"
import style0 from "./page-title.vue?vue&type=style&index=0&id=797c27c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c27c4",
  null
  
)

export default component.exports